import { useEffect, useRef, useState } from "react";
import Icon from "./Icon";
import styles from "./SelectBox.module.css";

interface selectBoxProps {
    optionList: string[];
    selectOption?: (option: number) => void;
    selected: number;
}
/**
 * @author cjs
 * @date 2024-09-12 11:26:58
 * @remark selectBox
 * @param props
 * @props selectBoxProps
 *      optionList(required) : selectBox에 들어갈 데이터
 *      selectOption : 목록 선택시 설정할 함수
 *      selected(required) : selectBox 목록 중 선택된 index 값
 * @returns SelectBox
 */

function SelectBox(props: selectBoxProps) {
    const [selected, setSelected] = useState<string>(props.optionList[props.selected]);
    const [isOptionClick, setIsOptionClick] = useState<boolean>(false);
    const optionRef = useRef<HTMLDivElement>(null);
    const showOption = () => {
        setIsOptionClick(!isOptionClick);
    };

    const clickOption = (option: string, idx: number) => {
        setSelected(option);
        setIsOptionClick(false);
        props.selectOption && props.selectOption(idx);
    };

    const outSideClick = (e: MouseEvent) => {
        if (isOptionClick && optionRef.current && !optionRef.current.contains(e.target as Node)) {
            setIsOptionClick(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", outSideClick);
        return () => {
            document.removeEventListener("mousedown", outSideClick);
        };
    }, [isOptionClick]);

    useEffect(() => {
        setSelected(props.optionList[props.selected]);
    }, [props.optionList, props.selected]);

    return (
        <div className={styles.wrap} onClick={showOption} ref={optionRef}>
            <button className={styles.wrapOption}>
                <span>{selected}</span>
                <span className={styles.wrapIcon}>
                    {isOptionClick ? <Icon name={"arrowUp"} color="darkGrey" /> : <Icon name={"arrowDown"} color="darkGrey" />}
                </span>
            </button>

            <ul className={`${styles.wrapOptionItem} ${isOptionClick ? styles.active : styles.hide}`}>
                {props.optionList.map((data, idx) => {
                    return (
                        <li className={styles.optionItem} key={idx} value={data} onClick={() => clickOption(data, idx)}>
                            {data}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
export default SelectBox;
